import titleAndDescription from './TitleAndDescription';
import comments from './Comments';

export default [titleAndDescription, comments];
